module.exports = __webpack_public_path__ + "media/vr_camera.4ad7f3fb.mp4";